// eslint-disable-next-line jira/export/no-external-exports
export { default } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/multi-select-cell';
